var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('McButton',{staticClass:"mc-btn-add-addenddum",attrs:{"variant":"secondary","text":"Ubah Data","icon":"icon-outline_edit"},on:{"click":_vm.handleCreateAddendum}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }